/* eslint-disable */

import React, { useEffect, useRef, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import {
  Box,
  Button,
  Typography,
  Container,
  Table,
  Card,
  TableBody,
  TableCell,
  FormControl,
  Select,
  Alert,
  Snackbar,
  MenuItem,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Stack,
  CircularProgress,
  Pagination
} from '@mui/material';

import { crossMarkString, getTripStatusColor } from '../utils/Utilities';
import ConfirmAlertDialog from '../components/ConfirmDialog';

// components
import Page from '../components/Page';
import {
  AddVehicleModal,
  EditDriverModal,
  ReportIssuesModal,
  VehicleMoreMenu
} from '../components/_dashboard/smartlock';
import { DeleteVehicleByID, GetAllVehicles } from '../network/Vehicles';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import TramOutlinedIcon from '@mui/icons-material/TramOutlined';
import ElectricRickshawOutlinedIcon from '@mui/icons-material/ElectricRickshawOutlined';
import SailingOutlinedIcon from '@mui/icons-material/SailingOutlined';
import { ReactComponent as VehicleIcon } from '../icons/vectorsidebar_vehicle.svg';
import useFeatures from '../components/customContextProviders/FeatureContext';
import Header from '../components/navbar/Header';
import NoDataAvailable from '../components/_dashboard/smartlock/NoDataAvailable';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { HeaderHeight, PageHeaderHeight } from '../Constants';

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  },
  tableCellStyle: {
    fontSize: {
      xs: '12px',
      md: '14px'
    },
    fontWeight: 700,
    padding: {
      xs: '8px',
      md: '16px'
    },
    backgroundColor: '#FFFFFF'
  },
  tablePaper: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF'
  },
  tableContainer: {
    flexGrow: 1,
    height: `calc(100vh - ${HeaderHeight + PageHeaderHeight + 56 + 40}px)`,
    overflow: 'auto'
  }
}));

const LoaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50px'
});
const PageHeader = styled('Box')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'start',
  gap: 1,
  flexDirection: 'row !important',
  height: '50px'
}));

export default function VehiclesSmartLock() {
  const classes = useStyles();
  const location = useLocation();
  const feature = useFeatures();

  const vehicleType = location?.state?.type || '';

  const [open, setOpen] = useState(false);
  const [vehicleDataList, setVehicleDataList] = useState([]);
  const [isAddVehicleModalOpen, setIsAddVehicleModalOpen] = useState(false);
  const [vehicleFilterVal, setVehicleFilterVal] = useState('');
  const [isEditDriverModalOpen, setIsEditDriverModalOpen] = useState(false);
  const [editDriverData, setEditDriverData] = useState({});
  const [selectedvehicleData, setSelectedVehicleData] = useState({});
  const [openConfirmAlertDialog, setOpenConfirmAlertDialog] = useState(false);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [vehiclePagination, setVehiclePagination] = useState([]);
  const [initialRender, setInitialRender] = useState(false);
  const [confirmAlertDialogMetas, setConfirmAlertDialogMetas] = useState({
    message: '',
    title: '',
    positiveBtnLable: '',
    negativeBtnLabel: ''
  });

  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const vertical = 'bottom';
  const horizontal = 'left';

  const handleSnackBarClose = (event, reason) => {
    // if (reason === 'clickaway') {
    //   return;
    // }
    setAlertMetas({ ...alertMetas, snackBarOpened: false });
  };

  const handleVehicleFilterValChange = (event) => {
    setPage(1);
    setVehicleFilterVal(event.target.value);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const getVehicles = async (page, search, vehicleFilterVal) => {
    try {
      setLoader(true);
      const res = await GetAllVehicles(page, search, vehicleFilterVal);
      if (res.data) {
        setVehiclePagination(res?.data);
        setVehicleDataList(res?.data?.data);
      }
    } catch (error) {
      console.error('Error fetching vehicles:', error);
    } finally {
      setLoader(false);
    }
  };

  const handleVehicleSearch = (value) => {
    setSearch(value);
  };

  const searchVehicle = () => {
    setPage(1);
    getVehicles(page, search, vehicleFilterVal);
  };

  const deleteVehicleById = async (vehicleId) => {
    try {
      const res = await DeleteVehicleByID(vehicleId);
      if (res) {
        setAlertMetas({
          ...alertMetas,
          severity: 'error',
          snackBarOpened: true,
          msg: 'Vehicle Deleted!'
        });
        setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
        getVehicles(page, search, vehicleFilterVal);
      }
    } catch (error) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message || 'Failed to delete vehicle.'
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  const handleUserMoreMenuClick = (action, vehicleData) => {
    switch (action) {
      case 'edit_vehicle': {
        setSelectedVehicleData(vehicleData);
        setIsAddVehicleModalOpen(true);
        break;
      }
      case 'delete_vehicle': {
        setSelectedVehicleData(vehicleData);
        setConfirmAlertDialogMetas({
          ...confirmAlertDialogMetas,
          message: 'Are you sure want to delete this vehicle ?',
          title: 'Delete',
          positiveBtnLable: 'Confirm',
          negativeBtnLabel: 'Cancel'
        });
        setOpenConfirmAlertDialog(true);
        break;
      }
      default: {
        return;
      }
    }
  };

  function onAddVehicleAction(action) {
    getVehicles(page, search, vehicleFilterVal);
  }

  useEffect(() => {
    if (vehicleType) {
      setVehicleFilterVal(vehicleType);
    }
    setInitialRender(true);
  }, [vehicleType]);

  useEffect(() => {
    if (initialRender) {
      getVehicles(page, search, vehicleFilterVal);
    }
  }, [vehicleFilterVal, page, search, initialRender]);

  return (
    <Page title="Vehicles">
      <Header
        onOpenSidebar={() => setOpen(true)}
        handleSearch={handleVehicleSearch}
        handleSubmit={searchVehicle}
        name="Vehicle Management"
        showSearch={true}
      />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>

      <Container maxWidth="false" disableGutters sx={{ padding: 0 }}>
        <PageHeader>
          {feature?.vehicle?.addVehicle && (
            <Button
              variant="outlined"
              size="medium"
              onClick={() => setIsAddVehicleModalOpen(true)}
              sx={{ backgroundColor: '#FFFFFF', boxShadow: '0px 10px 19px 1px #EAEAFF' }}
            >
              Add Vehicle
            </Button>
          )}
          <FormControl data-testid="vehicle-sort-by" size="small" sx={{ minWidth: 150 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600 }}>
                Vehicle Type
              </Typography>
              <Select
                sx={{
                  fontSize: { xs: '12px', sm: '14px' },
                  fontWeight: '500',
                  minWidth: '130px',
                  borderRadius: '12px'
                }}
                labelId="vehicle-filter-select-label"
                id="vehicle-filter-select"
                value={vehicleFilterVal}
                IconComponent={ExpandMoreIcon}
                onChange={handleVehicleFilterValChange}
              >
                <MenuItem sx={{ gap: 2 }} className={classes.menuItem} value={''}>
                  {' '}
                  {VehicleIcon ? (
                    <VehicleIcon sx={{ mr: 1, width: '20px', height: '20px' }} />
                  ) : null}{' '}
                  All
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'truck'}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    {LocalShippingOutlinedIcon ? (
                      <LocalShippingOutlinedIcon sx={{ mr: 1 }} />
                    ) : null}
                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                      Truck
                    </Typography>
                  </Box>
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'train'}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    {TramOutlinedIcon ? <TramOutlinedIcon sx={{ mr: 1 }} /> : null}
                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                      Train
                    </Typography>
                  </Box>
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'tempo'}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    {ElectricRickshawOutlinedIcon ? (
                      <ElectricRickshawOutlinedIcon sx={{ mr: 1 }} />
                    ) : null}
                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                      Tempo
                    </Typography>
                  </Box>
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'ship'}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    {SailingOutlinedIcon ? <SailingOutlinedIcon sx={{ mr: 1 }} /> : null}
                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                      Ship
                    </Typography>
                  </Box>
                </MenuItem>
                <MenuItem className={classes.menuItem} value={'container'}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    {LocalShippingIcon ? <LocalShippingIcon sx={{ mr: 1 }} /> : null}
                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                      Container
                    </Typography>
                  </Box>
                </MenuItem>
              </Select>
            </Box>
          </FormControl>
        </PageHeader>

        <Card sx={{ width: '100%' }}>
          <Paper className={classes.tablePaper}>
            <TableContainer data-testid="vehicle-data-table" className={classes.tableContainer}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {/* <TableCell sx={{fontWeight:'bold'}} align="left"></TableCell> */}
                    <TableCell className={classes.tableCellStyle} align="left">
                      Vehicle Name
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} align="left">
                      Registration No{' '}
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} align="left">
                      Type
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} align="left">
                      Load Capacity
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} align="left">
                      Vehicle Speed
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} align="left">
                      Driver
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} align="left">
                      Trip Id
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} align="left">
                      Trip Status
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} align="left"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <LoaderContainer>
                          <CircularProgress size={30} />
                        </LoaderContainer>
                      </TableCell>
                    </TableRow>
                  ) : vehicleDataList.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <NoDataAvailable />
                      </TableCell>
                    </TableRow>
                  ) : (
                    vehicleDataList?.map((row) => (
                      <TableRow
                        key={row?.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          {row?.name ? row?.name : '---'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          {row?.registrationNo ? row?.registrationNo : '---'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          {row?.type?.toUpperCase()}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          {row?.details?.loadCapacity ? row?.details?.loadCapacity : '---'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          {row?.vehicle_speed ? `${row?.vehicle_speed} km/hr` : '---'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          {row?.vehicleLastTrip?.trip?.driverName
                            ? row?.vehicleLastTrip?.trip?.driverName
                            : '---'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          {row?.vehicleLastTrip?.tripId
                            ? crossMarkString(row?.vehicleLastTrip?.tripId)
                            : '---'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '5vw',
                            textWrap: 'nowrap',
                            textTransform: 'capitalize',
                            padding: {
                              xs: '8px',
                              md: '16px'
                            },
                            fontSize: {
                              xs: '12px',
                              md: '14px' // Larger screens
                            }
                          }}
                        >
                          {row?.vehicleLastTrip?.trip?.status !== undefined &&
                          row?.vehicleLastTrip?.trip?.status !== null &&
                          row?.vehicleLastTrip?.trip?.status !== '' ? (
                            <Chip
                              sx={{
                                '& .MuiChip-label': {
                                  color: 'white',
                                  fontSize: '12px',
                                  textTransform: 'capitalize'
                                },
                                height: '24px',
                                minWidth: '5vw',
                                float: 'end'
                              }}
                              label={row?.vehicleLastTrip?.trip?.status}
                              variant="contained"
                              color={getTripStatusColor(row?.vehicleLastTrip?.trip?.status)}
                            />
                          ) : (
                            <Typography>---</Typography>
                          )}
                        </TableCell>

                        {Object.values(feature?.vehicle).some((value) => value) && (
                          <TableCell
                            align="right"
                            sx={{
                              padding: {
                                xs: '8px',
                                md: '16px'
                              }
                            }}
                          >
                            <VehicleMoreMenu
                              vehicleData={row}
                              handleClicks={(e) => handleUserMoreMenuClick(e, row)}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {vehiclePagination?.data?.length !== 0 && (
              <Stack
                sx={{
                  marginTop: '10px',
                  marginBottom: '10px'
                }}
              >
                <Pagination
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                  count={vehiclePagination?.totalPages}
                  showFirstButton
                  showLastButton
                  onChange={handlePageChange}
                  page={page}
                  total={vehiclePagination?.total}
                />
              </Stack>
            )}
          </Paper>
        </Card>

        {isAddVehicleModalOpen && (
          <AddVehicleModal
            openAssignedModal={isAddVehicleModalOpen}
            onAction={(action) => onAddVehicleAction(action)}
            vehicleData={selectedvehicleData}
            setIsAddVehicleModalOpen={setIsAddVehicleModalOpen}
            setVehicleData={setSelectedVehicleData}
          />
        )}

        <ConfirmAlertDialog
          openConfirmAlertDialog={openConfirmAlertDialog}
          message={confirmAlertDialogMetas?.message}
          title={confirmAlertDialogMetas?.title}
          positiveBtnLable={confirmAlertDialogMetas?.positiveBtnLable}
          negativeBtnLable={confirmAlertDialogMetas?.negativeBtnLabel}
          handleClose={() => setOpenConfirmAlertDialog(false)}
          handlePositiveClose={() => {
            deleteVehicleById(selectedvehicleData?.id);
            setOpenConfirmAlertDialog(false);
          }}
          handleNegativeClose={() => setOpenConfirmAlertDialog(false)}
        />
      </Container>
    </Page>
  );
}
